import React, { useState } from 'react';
import LiveChat from '../../../../components/LiveChat';
import Modal from '../../../../components/Modal';
import { CustomerCareIcon } from '../../../../utils/svg';
import { ExclamationCircleIcon } from '@heroicons/react/24/solid';

const CustomerCare = () => {
	const [isOpen, setIsOpen] = useState(false);

	const handleOpenChat = () => {
		if (window.openFreshChat) {
			window.openFreshChat();
		}
	};

	const handleConfirm = () => {
		setIsOpen(false);
		handleOpenChat();
	};

	return (
		<>
			<div
				className="absolute top-4 right-16 z-5 cursor-pointer"
				onClick={() => setIsOpen(true)}
			>
				<CustomerCareIcon
					className="h-8 w-auto text-white"
					opacity="1"
				/>
			</div>

			{process.env.REACT_APP_NODE_ENV === 'production' && <LiveChat />}

			<Modal isOpen={isOpen} onClose={() => setIsOpen(false)}>
				<div className="bg-white p-4 rounded-xl shadow-custom">
					<div className="flex justify-center">
						<div className="bg-gray-300 h-1.5 w-10 rounded-full" />
					</div>

					<div className="flex justify-center mt-8">
						<ExclamationCircleIcon className="h-14 w-auto fill-[var(--rose-violet)]" />
					</div>

					<div className="my-5 text-center">
						<div className="text-gray-900 text-sm font-semibold">
							Anda akan diarahkan ke Layanan Pelanggan
						</div>
						<div className="text-gray-900 text-xs pt-2">
							Apakah Anda yakin ingin melanjutkan?
						</div>
					</div>

					<div className="flex gap-4">
						<button
							className="w-full bg-white text-[var(--rose-violet)] border border-[var(--rose-violet)] font-semibold text-sm p-3"
							onClick={() => setIsOpen(false)}
							id="merchant_change_cart_cancel"
						>
							Batal
						</button>

						<button
							onClick={handleConfirm}
							className="w-full bg-[var(--rose-violet)] text-white font-semibold text-sm p-3"
							id="merchant_change_cart_confirm"
						>
							Ya, Lanjutkan
						</button>
					</div>
				</div>
			</Modal>
		</>
	);
};

export default CustomerCare;
